import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

const container = document.getElementById('at-wayfinding');
const root = createRoot(container);
root.render(<App tab="home" />);
